import * as React from 'react'

interface PlayButtonProps {
  wrapperStyle?: string
  svgStyle?: string
  circleStyle?: string
  triangleStyle?: string
}

const PlayButton = ({ wrapperStyle, svgStyle, circleStyle, triangleStyle }: PlayButtonProps) => (
  <div className={wrapperStyle}>
    <svg className={svgStyle} viewBox="0 0 36 36">
      <circle className={circleStyle} cx="18" cy="18" r="17" />
      <path className={triangleStyle} d="M14.6821364,10.8388295 C14.0320227,10.4648523 13.4998636,10.7726932 13.4998636,11.5226932 L13.4998636,24.4772386 C13.4998636,25.2272386 14.0320227,25.5350795 14.6821364,25.1611023 L25.9542955,18.6797386 C26.6044091,18.3057614 26.6044091,17.6941705 25.9542955,17.3201932 L14.6821364,10.8388295 Z"></path>
    </svg>
  </div>
)

export default PlayButton
